'use client';

import { useState, useEffect } from 'react';

interface AnimatedPlaceholderProps {
  placeholders: string[];
  className?: string;
}

export function AnimatedPlaceholder({ placeholders, className }: AnimatedPlaceholderProps) {
  const [currentPlaceholder, setCurrentPlaceholder] = useState('');
  const [isDeleting, setIsDeleting] = useState(false);
  const [loopNum, setLoopNum] = useState(0);

  useEffect(() => {
    const handleTyping = () => {
      const i = loopNum % placeholders.length;
      const fullText = placeholders[i];

      if (isDeleting) {
        setCurrentPlaceholder(fullText.substring(0, currentPlaceholder.length - 1));
      } else {
        setCurrentPlaceholder(fullText.substring(0, currentPlaceholder.length + 1));
      }

      if (!isDeleting && currentPlaceholder === fullText) {
        setTimeout(() => setIsDeleting(true), 1500);
      } else if (isDeleting && currentPlaceholder === '') {
        setIsDeleting(false);
        setLoopNum(loopNum + 1);
      }
    };

    const typingSpeed = isDeleting ? 60 : 120;
    const timer = setTimeout(handleTyping, typingSpeed);

    return () => clearTimeout(timer);
  }, [currentPlaceholder, isDeleting, loopNum, placeholders]);

  return (
    <span className={className}>
      {`Search "${currentPlaceholder}"`}
    </span>
  );
} 